import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import { useSum } from '../../context/SumContext';
import NumberFormat from 'react-number-format';
import React, { useState, useEffect } from "react";
import { db } from "../../config/Firebase";
import { CircularProgress, InputBase } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: 500,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 30,
    fontWeight: 600,
  },
  pos: {
    marginBottom: 12,
  },
  chip: {
    margin: 3,
  },
});

const TopTick = () => {
  // const { sum: rows, ...data } = useSum();
  //   const { activeUser } = useAuth();
  const classes = useStyles();
  const [initialData, setInitialData] = useState(null);
  const [timeData, setTimeData] = useState(null);
  const [tickData, setTickData] = useState(null);
  const [orderData, setOrderData] = useState(null);
  
  // let tickData, orderData;

  useEffect(() => {
    let historyData;
    db.collection("sum")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if (doc.id === 'thirtyticker') {
            // tickData = doc.data();
            setTickData(doc.data());
          } else if (doc.id === 'thirtyorder') {
            // orderData = doc.data();
            setOrderData(doc.data());
          } else if (doc.id === 'thirtytime') {
            setTimeData(doc.data());
            
            debugger;
          }
          // if (doc.id === "history") {
          //   historyData = doc.data().topuoa;
          //   setData(historyData);
          //   setInitialData(historyData);
          // }
        });
        if (tickData !== null && orderData !== null && timeData !== null) {
          setInitialData(tickData);
        }

      });
  }, []);

  // rows.forEach((doc) => {
    
  // });
  debugger;
  return (
    <div style={{ fontSize: `0.8rem` }}>
      <section className='pt-5 mb-5'>
        <div className='container-fluid mb-5'>
          <h1 className='text-center font-weight-bold my-3 py-3'>
            Real Time Unusual Option Activity
          </h1>
          <h3 className='text-center font-weight-light text-black-50  mt-3 mb-4 py-1'>
            <span className='border-bottom pb-2 border-secondary'>
              Real Time Market Recap
            </span>
          </h3>
          <div className='mb-4'>
            {timeData === null || orderData === null || tickData === null  ? (
                      <>
                        {" "}
                        <CircularProgress />{" "}
                      </>
                    ) : (
                      <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card
                  className={` ${classes.root} mx-auto rounded-xl shadow-lg`}
                  variant='outlined'
                >
                  <CardContent className='bg-success-2 text-white'>
                    <Typography className={classes.title}>
                      {timeData.time}
                    </Typography>
                    <Typography
                      variant='h6'
                      component='h2'
                      className={classes.pos}
                    >
                      Most Active stocks in past 30 minutes :
                    </Typography>
                    {Object.values(tickData).map((element) => (
                      <Typography variant='body2' component='p'>
                        <span>1. {element.ticker}</span>

                        <Chip
                          spacing={3}
                          className={`border-0 text-white`}
                          label={
                            <NumberFormat
                              value={element.premium}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={'$'}
                            />
                          }
                          clickable
                          variant='outlined'
                        />
                      </Typography>
                    ))}
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card
                  className={` ${classes.root} mx-auto rounded-xl shadow-lg`}
                  variant='outlined'
                >
                  <CardContent className='bg-success-2 text-white'>
                    <Typography className={classes.title}>
                      {timeData.time}
                    </Typography>
                    <Typography variant='h6' component='h2' className='mb-3'>
                      Most active order in past 30 minutes :
                    </Typography>
                    {Object.values(orderData).map((element) => (
                      <Typography variant='body2' component='p'>
                        <div className='mb-2'>1. {element}</div>
                      </Typography>
                    ))}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
                    )}
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default TopTick;
